import React, { Fragment } from 'react'

//componets
import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import NewsletterTwo from '../../../components/call-to-action/NewsletterTwo'
import FooterThree from '../../../components/footer/FooterThree'

const Team = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">

                <ThemeMenuThree />

                <PageTitle title="팀 소개" parentTo="/about" parentLabel="코담 소개" />

                <section className="codam-team team-sec-two mt-0 pt-145 pb-145 pt-lg-55 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-55">
                                    <h6 className="sub-title mb-20">CODAM 팀</h6>
                                    <h2 className="sect-title">전문가로 구성된 조직</h2>
                                    <p className="text-white mt-20 mx-auto" style={{ maxWidth: '640px', opacity: 0.85 }}>
                                        기획부터 설계·개발·운영까지, 엔터프라이즈 프로젝트를 책임지는 구성원입니다. 각 분야 리더가
                                        일관된 품질 기준으로 협업합니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <NewsletterTwo />

                <FooterThree />
            </div>
        </Fragment>
    )
}

export default Team
